module.exports = __webpack_public_path__ + "img/icon_j3.652fbd7.png";